














































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { PosSession } from '@pos/interfaces/pos-session';
import moment from 'moment';
import { appConfig } from '@/config/app-config';

@Component({
  name: 'bpc-header-pos-session-area',
  components: {
    'font-awesome-icon': FontAwesomeIcon,
  },
})
export default class HeaderPosSessionArea extends Vue {
  get openPosSession(): PosSession {
    return this.$store.getters['pos/openPosSession'];
  }

  get activatedPosV2(): boolean {
    return appConfig.modules.activatePosV2 && this.$store.getters['centerSettings/usePosV2'];
  }

  formatDateTime(date, time): string {
    return moment(`${date} ${time}`).format('DD/MM/YYYY HH:mm');
  }

  togglePosModalsOpened() {
    this.$store.commit('pos/toggleModalsOpened');
  }

  toggleCheckoutDrawer() {
    if (this.activatedPosV2) {
      this.$router.push({
        name: 'pos-page',
        params: {
          initialPosSessionId: `${this.openPosSession.id}`,
        },
      });
      // go to pos page
    } else {
      this.$store.commit('pos/toggleDrawer');
    }
  }

  toggleResumeSessionDrawer() {
    console.log('click resume');
    this.$store.commit('pos/toggleResumeSessionDrawer');
    this.togglePosModalsOpened();
  }

  toggleCloseSessionDrawer() {
    this.$store.commit('pos/toggleCloseSessionDrawer');
    this.togglePosModalsOpened();
  }
}
